import axios from 'axios'
import { Message } from 'element-ui'
import { httphost } from '@/utils/global'

// create an axios instance
// 处理 process 未定义的问题
const getBaseURL = () => {
  return '/api';
};

const service = axios.create({
  // baseURL: getBaseURL(), // url = base url + request url
  baseURL: httphost + '/api',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Message.error(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 1) {
      Message.error(res.msg);
    }
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default service

